import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title className="user-select-none">{props.title ? props.title + " | " : null}Limtzo</title>
    </Helmet>
  );
};
export default Head;
